import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@core/auth/models/api-response.model';
import { ApiService } from '@core/auth/services/api.service';
import {
    WhatsAppCoexistenceStatus,
    WhatsAppEmbeddedSignupAccount,
    WhatsAppEmbeddedSignupCompletePayload,
} from '@features/settings/interfaces/whatsapp-embedded-sigup-account.interface';

@Injectable({
    providedIn: 'root',
})
export class WhatsAppOnboardingService {
    constructor(private readonly api: ApiService) {}

    getStatus(): Observable<ApiResponse<WhatsAppEmbeddedSignupAccount[]>> {
        return this.api.get<ApiResponse<WhatsAppEmbeddedSignupAccount[]>>('whatsapp/embedded-signup/status');
    }

    getCoexistenceStatus(): Observable<ApiResponse<WhatsAppCoexistenceStatus>> {
        return this.api.get<ApiResponse<WhatsAppCoexistenceStatus>>('whatsapp/coexistence/status');
    }

    complete(
        payload: WhatsAppEmbeddedSignupCompletePayload,
    ): Observable<ApiResponse<WhatsAppEmbeddedSignupAccount>> {
        return this.api.post<ApiResponse<WhatsAppEmbeddedSignupAccount>>('whatsapp/embedded-signup/complete', payload);
    }
}
